import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const EditEmployeeModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edit Employee <small className="text-muted">(EMP-0024)</small></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col md={6}><Form.Control placeholder="First Name *" defaultValue="Stephan" /></Col>
            <Col md={6}><Form.Control placeholder="Last Name" defaultValue="Peralt" /></Col>
            <Col md={6}><Form.Control placeholder="Employee ID *" defaultValue="EMP-0024" /></Col>
            <Col md={6}><Form.Control type="date" defaultValue="2023-01-01" /></Col>
            {/* Add more fields as needed */}
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>Cancel</Button>
        <Button variant="primary" style={{ backgroundColor: '#FF6B00', border: 'none' }}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditEmployeeModal;